import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import styled from 'styled-components';

import Calendar from 'react-calendar';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

// import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import TextFill from './TextFill';

const StyledCustomCalendar = styled.div`
.fc {
    max-height: 60vh;
    overflow-y: auto;
    overflow: scroll;
}
.fc-header-toolbar {
    position: sticky;
    top: 0px;
    z-index: 10;
}
.react-calendar {
    &__navigation {
        margin-right: -5px;
        margin-bottom: 10px;
        display: flex;
        &__label {
            width: 100%;
        }
        &__arrow {
            height: 100%;
            flex-shrink: 0;
        }
        button {
            appearance: none;
            border: none;
            padding: 15px;
            box-sizing: border-box;
            border: solid 1px rgba(255, 255, 255, 0.1);
            background-color: transparent;
            color: white;
            font-weight: 800;
            font-size: 18px;
            margin-right: 5px;
            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
                cursor: pointer;
            }
        }
    }

    &__month-view {
        text-align: center;
        &__weekdays {
            margin-bottom: 10px;
            &__weekday {
                font-size: 16px;
                text-decoration: none;
            }
        }
    }
    &__tile {
        appearance: none;
        border: none;
        padding: 15px;
        box-sizing: border-box;
        border: solid 1px rgba(255, 255, 255, 0.1);
        background-color: transparent;
        color: white;
        font-weight: 800;
        font-size: 18px;
        margin-right: 0px;
        position: relative;
        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }
    }
    &__tile--now {
        background-color: rgba(230, 125, 34, 0.4);
        /* &::after {
            content: 'today';
            display: block;
            font-size: 12px;
            font-weight: 100;
            height: 0px;
            color: #ff7675;
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
        } */
    }
}
`

class CustomCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDate: null, // Date
            filteredEvents: this.props.events.length < 20 ? this.props.events : null // [{},...]
        }
    }

    init() {
        if(this.props.events.length >= 0 && this.props.events.length < 20) {
            this.setState({
                filteredEvents: this.props.events
            });
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.events !== this.props.events) {
            this.init();
        }
    }
    
    handleEventClick(e) {
        if(this.props.onEventClick) {
            this.props.onEventClick(e);
        }
    }

    handleMonthClick(date) {
        let selectedDate = new Date(date.setHours(0, 0, 0, 0));
        let selectedDatePlusDay = selectedDate.getTime() + (1 * 1000 * 60 * 60 * 24);

        let filteredEvents = this.props.events.filter((e) => {
            return new Date(e.start) >= selectedDate && new Date(e.start) < selectedDatePlusDay;
        });
        let filteredBookings = this.props.bookings.filter((e) => {
            return new Date(e.event.start) >= selectedDate && new Date(e.event.start) < selectedDatePlusDay;
        });

        let creditsOnDay = 0;

        filteredBookings.forEach((b) => {
            if(this.props.projectMap[b.project.id] != null) {
                creditsOnDay += Number(this.props.projectMap[b.project.id].cost);
            }
        });

        this.setState({
            currentDate: date,
            filteredEvents: filteredEvents,
            creditsOnCurrentDate: creditsOnDay,
        });
    }

    renderTopBar() {
        if(!(this.state.filteredEvents && this.state.currentDate == null)) {
            return (
                <div className="hw-widget__top-bar">
                    <div className="hw-widget__top-bar__button" onClick={() => this.setState({currentDate: null, filteredEvents: null, creditsOnCurrentDate: null})}>{'<'}</div>
                    <h3 style={{margin: '0', textAlign: 'right'}}><b>{this.state.currentDate ? moment(this.state.currentDate).format('dddd, LL') : ''}</b></h3>
                </div>
            )
        }
    }

    render() {
        if(this.state.creditsOnCurrentDate >= 2 && this.props.plan == 'Professional') {
            return <>
                {this.renderTopBar()}
                <TextFill small>You cannot book more than 2 credits for a particular day.<br/>Please choose another date.</TextFill>
            </>
        }
        if(this.state.filteredEvents) {
            let c = [];
            if(this.state.filteredEvents.length > 0) {
                for(const e of this.state.filteredEvents) {
                    let startDate = moment(e.start).format('LL');
                    let startTime = moment(e.start).format('LT');
                    let endDate = moment(e.end).format('LL');
                    let endTime = moment(e.end).format('LT');
                    c.push(
                        <div key={e.start} className="hw-widget__events__item">
                            <div className="hw-widget__events__details">
                                <h3>{startTime} - {endTime}</h3>
                                <p>{startDate}</p>
                            </div>
                            <div className="hw-widget__events__select" onClick={() => this.handleEventClick(e)}>
                                <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    )
                }
            } else {
                c.push(
                    <TextFill small>There are no events available for this date.</TextFill>
                )
            }
            return (
                <React.Fragment>
                    {this.renderTopBar()}
                    <div className="hw-widget__events">
                        {c}
                    </div>
                </React.Fragment>
            )
        }
        return (
            <StyledCustomCalendar>
                <Calendar 
                calendarType="US" 
                onChange={(d) => this.handleMonthClick(d)}
                tileDisabled={({ date, view }) => {
                    const key = date.toISOString().slice(0, 10);
                    if(view !== "month"){
                      return false
                    }
                    return (
                      !this.props.events.some((e) => e.start.includes(key))
                    );
                }}
                />
            </StyledCustomCalendar>
        )

    }
}
 
export default CustomCalendar;